<template>
  <div class="graphic-one-updown" :style="itemStyle">
    <div class="right-cont" :class="{
      'is-pad': specialStyle.oneGroupImageLeft=='1' &&
      (specialStyle.oneGroupBorder || specialStyle.oneGroupBorderShadow)}" :style="rightStyle">
      <h2 class="graphic-title" :style="titleStyle" v-if="specialData.includeItemsTitle">{{item.titleName}}</h2>
      <p class="summary" :style="summaryStyle" v-if="specialData.includeItemsDes">{{item.titleDes}}</p>
    </div>
    <div class="left-pic" :class="{'is-after': item.fileType == 2 || item.selectType == 2}" v-if="specialData.includeItemsImageOrVideo" :style="imgBoxStyle">
      <img :src="item.entryImg" v-if="item.entryImg" :alt="item.titleName" class="picture" :style="imgStyle" />
      <img :src="defaultImg" v-else :alt="item.titleName" class="picture default-picture" :style="imgStyle" />
      <img class="play-btn" v-if="item.fileType == 2 || item.selectType == 2" :src="playBtn" alt="">
    </div>
  </div>
</template>
<script>
import playBtn from '../../asset/images/play-btn.png'
export default {
  data() {
    const { tempData: { specialData, specialStyle, specialEntryList }, terminal } = this.data
    return {
      playBtn,
      specialData,
      specialStyle,
      specialEntryList,
      terminal,
    }
  },
  props: {
    data: {
      type: Object
    },
    item: {
      type: Object,
    },
    defaultImg: {
      type: String
    }
  },
  computed: {

    imgStyle(){
      const {
        imgRadius=false,
        imgShadow=false,
        imgBorder=false,
        // imgBorderColor='',
        imgBackgroundColor='',
      } =  this.specialStyle;
      return {
        backgroundColor: imgBackgroundColor?imgBackgroundColor:'',
        borderRadius: imgRadius?'4px':'0',
        boxShadow: imgShadow?'0px 0px 4px 0px rgba(0, 0, 0, 0.1)':'',
        border: imgBorder?`1px solid #D6DEEA`:'none',
      }
    },
    imgBoxStyle() {
      const {
        imgRadius=false,
        imgShadow=false,
        imgBorder=false,
        // imgBorderColor='',
        oneGroupImageLeft
      } =  this.specialStyle;
      return {
        borderRadius: imgRadius?'4px':'0',
        boxShadow: imgShadow?'0px 0px 4px 0px rgba(0, 0, 0, 0.1)':'',
        border: imgBorder?`1px solid #D6DEEA`:'none',
        margin: oneGroupImageLeft=='1'? '0' : '0 4px 0 0'

      }
    },
    itemStyle(){
      const {
        oneGroupBorder,
        oneGroupBGColor,
        oneGroupBorderRadius=false,
        oneGroupBorderShadow,
        oneGroupImageLeft,
      } =  this.specialStyle;
      // const {includeItemsDes,includeItemsTitle} = this.specialData;
      return {
        border: oneGroupBorder?'1px solid #D6DEEA':'none',
        backgroundColor: oneGroupBGColor?oneGroupBGColor:'none',
        boxShadow: oneGroupBorderShadow?'0px 0px 4px 0px rgba(0, 0, 0, 0.1)':'none',
        borderRadius: oneGroupBorderRadius && '4px',
        padding: oneGroupImageLeft == '0' ? '4px 0' : '0',
        // marginBottom:topBottomInterval+'px'
        // marginBottom: !oneGroupBorder && !oneGroupBorderShadow && !oneGroupBorderRadius && 0
      }
    },
    rightStyle(){
      const {
        oneGroupBorder,
        oneGroupImageLeft,
        oneGroupBorderShadow,
        oneGroupBorderRadius,
      } =  this.specialStyle;
      if( !this.specialData.includeItemsImageOrVideo ){
        return {
          padding: !oneGroupBorder && !oneGroupBorderShadow && !oneGroupBorderRadius ? '10px 0':'10px'
        }
      }
      return {
        padding: oneGroupBorder && !(oneGroupImageLeft=='1') ?'0 6px':'',
      }
    },
    titleStyle(){
      const {
        titleSize,
        titleColor='#333',
        titleBold=false,
        titleAlign,
        titleLineHeight
      } =  this.specialStyle;
      return {
        fontSize: `${titleSize}px`,
        color: titleColor,
        fontWeight: `${titleBold?'bold':''}`,
        textAlign: titleAlign?titleAlign:'center',
        lineHeight: titleLineHeight ? titleLineHeight: ''
      }
    },
    summaryStyle(){
      const {
        descSize,
        descColor,
        descBold=false,
        descAlign,
        descLineHeight
      } =  this.specialStyle;
      return {
        fontSize: `${descSize}px`,
        color: `${descColor ? descColor:'#666'}`,
        fontWeight: `${descBold?'bold':''}`,
        textAlign: descAlign?descAlign:'center',
        lineHeight: descLineHeight ? descLineHeight : ''
      }
    }
  },
  methods: {

  },
  created(){

  }
}
</script>
<style lang="less" scoped>
.graphic-one-updown{
  margin-bottom: 24px;

  box-sizing: border-box;
  width: 48.2%;
  &:nth-child(2n+1){
    margin-right: 24px;
  }
  .left-pic{
    position: relative;
    box-sizing: border-box;
    overflow: hidden;
    width: 120px;
    height: 86px;
    .picture{
      width: 100%;
      height: 86px;
    }
    .play-btn{
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 50px;
      height: 50px;
    }
  }
  .right-cont {
    padding: 0 12px;
    &.is-pad{
      align-items: center;
      padding-left: 12px;
    }
    flex: 1;
    .graphic-title{
      // height: 40px;
      font-size: 28px;
      font-weight: 400;
      color: #333333;
      overflow: hidden;
      text-overflow: ellipsis;
      // display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      text-align: justify;
      max-width: 200px;
    }
    .summary{
      margin-top: 8px;
      font-size: 24px;
      font-weight: 400;
      color: #666666;
      -webkit-line-clamp: 1;
    }
    .create-time{
      margin-top: 12px;
      height: 36px;
      font-size: 24px;
      font-weight: 400;
      color: #999999;
      line-height: 36px;
    }
  }
}
</style>
